export const IS_BKASH_PAYMENT_ACTIVE = true;
export const IS_SSHL_PAYMENT_ACTIVE = true;
